import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { DateTime } from 'luxon';
import { of, switchMap } from 'rxjs';
import { ConfigService } from '../config.service';
import { Trip, TripDetail } from './commonInterfaces';
import { DataTransform, DateFieldTypes } from './dataTransformFunctions';


@Injectable({
  providedIn: 'root'
})
export class IncidentTripsService {

  constructor(
    private http: HttpClient,
    private config: ConfigService
  ) { }

  getTripsForIncidentId(incidentId: number) {
    return this.http.get<TripDetail[]>(`${this.config.dataApiUrl}/incidents/${incidentId}/trips`).pipe(
      switchMap( trips => {
        return DataTransform.replaceDatesArray<TripDetail>(trips, [{dateType: "local", fieldName: "tripDate"}, {dateType: "central", fieldName: "dateReserved"}])
      })
    );
  }

  getTripsForCustomer(customerId: number) {
    return this.http.get<Trip[]>(`${this.config.dataApiUrl}/customers/${customerId.toString()}/trips`).pipe(
      switchMap((trips) => {

        return DataTransform.replaceDatesArray<Trip>(trips, [
          {fieldName: "dateReserved", dateType: "central"},
          {fieldName: "tripDate", dateType: "local"},
          {fieldName: "timestamp", dateType: "utc"},
          {fieldName: "termsConditionsTimestamp", dateType: "central"},
          {fieldName: "fundraisingAgreementTimestamp", dateType: "central"},
          {fieldName: "covidPaymentAgreementTimestamp", dateType: "central"}
        ])

      })
    )
  }

}
